import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import clsx from "clsx"
import LoadingOverlay from "../LoadingOverlay";

function CustomConfirmationModal({ title, desc, show, handleClose, confirm,loading=false }) {
  return (
    <Modal show={show} onHide={loading ? false:handleClose} centered >
      <Modal.Header closeButton>
        <Modal.Title className={"annoucement-modal-title"}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{desc}</Modal.Body>
      <Modal.Footer className={clsx('justify-content-end')}>
        <Button variant="secondary" onClick={loading ? false:handleClose}>
          Close
        </Button>
        <Button variant="primary" className={clsx('ms-2')} onClick={confirm}>
          Confirm
          <LoadingOverlay isSemiLoading={true} loading={loading}></LoadingOverlay>
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CustomConfirmationModal;
